import { render, staticRenderFns } from "./EditVersionItem.vue?vue&type=template&id=aa74daac&scoped=true"
import script from "./EditVersionItem.vue?vue&type=script&lang=js"
export * from "./EditVersionItem.vue?vue&type=script&lang=js"
import style0 from "./EditVersionItem.vue?vue&type=style&index=0&id=aa74daac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74daac",
  null
  
)

export default component.exports